module.exports = __webpack_public_path__ + "static/media/HQ2.5f833d8f.gif";